export function getError500Labels(labels) {
    const { error500_title_text: error500TitleText = '', error500_subtitle_text: error500SubtitleText = '', error500_description_text: error500DescriptionText = '', error500_button_text: error500ButtonText = '', error500_logo_title: error500LogoTitle = '', } = labels;
    return {
        error500TitleText,
        error500SubtitleText,
        error500DescriptionText,
        error500ButtonText,
        error500LogoTitle,
    };
}
